<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <v-overlay :value="isLoading" class="my-overlay">
    <v-card class="screen-center" width="500">
      <v-progress-linear
        indeterminate
        height="10"
        color="yellow darken-2"
      ></v-progress-linear>
    </v-card>
  </v-overlay>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      isLoading: "isLoading",
    }),
  },
};
</script>

<style scoped>
.my-overlay >>> .v-overlay__content {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 999;
}
</style>
